import { Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import { environment } from "@wms/app";
import { DeploymentApiService } from '@wms/app/deployment/deployment-api/deployment-api.service';

interface User {
  enterpriseMode?: boolean;
  entId?: string;
  entName?: string;
  accountStatus?: string;
  accountId?: string;
  emailAddress?: string;
  displayName?: string;
}

interface Project {
  type?: string;
  platformType?: string;
  platformVersion?: string;
}

@Injectable({
  providedIn: 'root'
})
export class MixpanelService {
  constructor(private deploymentApiService: DeploymentApiService) { }

  async isEnabled(): Promise<boolean> {
    try {
      const envType = await (this.deploymentApiService.getEnvType() as Promise<string>);
      return environment.production && envType === "WMO";
    } catch {
      return false;
    }
  }

  async init(userToken: string, user: User = {}, project: Project = {}): Promise<void> {
    const isServiceEnabled = await this.isEnabled();
    if (!isServiceEnabled) return;

    const DEV_PROJ_TOKEN = 'a5b92de32d958d785d4a4274f37390dc';
    const PROD_PROJ_TOKEN = environment.MIX_PANEL_TOKEN;

    const projectToken = window.location.host !== 'www.wavemakeronline.com'
      ? DEV_PROJ_TOKEN
      : PROD_PROJ_TOKEN;

    const {
      enterpriseMode,
      entId,
      entName,
      accountStatus,
      accountId
    } = user;

    const {
      type,
      platformType,
      platformVersion
    } = project;

    // Initialize mixpanel
    mixpanel.init(projectToken, {
      track_pageview: "url-with-path",
      persistence: 'localStorage'
    });

    // Register super properties
    mixpanel.register({
      enterpriseMode,
      entId,
      entName,
      accountStatus,
      accountId,
      type,
      platformType,
      platformVersion
    });

    // Identify user
    mixpanel.identify(userToken);

    // Set user properties
    mixpanel.people.set({
      '$email': user.emailAddress,
      '$name': user.displayName
    });
  }

  async track(id: string, action: Record<string, any> = {}): Promise<void> {
    const isServiceEnabled = await this.isEnabled();
    if (!isServiceEnabled) return;

    mixpanel.track(id, action);
  }
}